<template>
  <component :is="wrapperTag" :class="wrapperClass">
    <button
      v-if="variant === 'mobile'"
      type="button"
      class="sidebar-close"
      @click="$emit('close')"
      aria-label="Close menu"
    >&times;</button>

    <div
      v-for="group in navGroups"
      :key="group.id"
      class="hc-sidenav__group"
    >
      <p v-if="group.label" class="hc-sidenav__group-label">{{ group.label }}</p>
      <button
        v-for="item in group.items"
        :key="item.id"
        type="button"
        class="hc-sidenav__item"
        :class="{ 'hc-sidenav__item--active': selectedTab === item.id }"
        :aria-current="selectedTab === item.id ? 'page' : null"
        @click="$emit('select-tab', item.id)"
      >
        <i class="mdi" :class="item.icon" aria-hidden="true"></i>
        <span>{{ item.label }}</span>
      </button>
    </div>

    <div
      v-if="showCompletionWidget"
      class="hc-sidenav__completion"
      role="button"
      tabindex="0"
      @click="$emit('open-completion')"
      @keyup.enter="$emit('open-completion')"
    >
      <div class="hc-sidenav__completion-ring" :style="{ '--score-pct': profileCompletionPercent }">
        <span>{{ profileCompletionPercent }}%</span>
      </div>
      <div class="hc-sidenav__completion-text">
        <strong>Profile strength</strong>
        <small>{{ profileCompletionPercent >= 80 ? 'Looking great!' : 'Tap to complete profile' }}</small>
      </div>
    </div>
  </component>
</template>

<script>
const NAV_GROUPS = [
  {
    id: 'jobs',
    label: 'Jobs',
    items: [
      { id: 'jobDetails', label: 'My jobs', icon: 'mdi-briefcase-outline' },
      { id: 'scheduledInterviews', label: 'Scheduled interviews', icon: 'mdi-calendar-clock' },
      { id: 'assessments', label: 'Assessments', icon: 'mdi-clipboard-text-outline' },
    ],
  },
  {
    id: 'profile',
    label: 'Profile',
    items: [
      { id: 'personalDetails', label: 'Personal details', icon: 'mdi-account-outline' },
      { id: 'educationalDetails', label: 'Education', icon: 'mdi-school-outline' },
      { id: 'experienceDetails', label: 'Work experience', icon: 'mdi-domain' },
    ],
  },
  {
    id: 'activity',
    label: 'Activity',
    items: [
      { id: 'profile_viewers', label: 'Profile viewers', icon: 'mdi-eye-outline' },
      { id: 'comments', label: 'Rating and comments', icon: 'mdi-comment-text-outline' },
    ],
  },
  {
    id: 'account',
    label: 'Account',
    items: [
      { id: 'selectSettings', label: 'Settings', icon: 'mdi-cog-outline' },
    ],
  },
];

export default {
  name: 'DashboardNav',
  props: {
    selectedTab: { type: String, required: true },
    profileCompletionPercent: { type: Number, default: 0 },
    variant: {
      type: String,
      default: 'desktop',
      validator: (v) => ['desktop', 'mobile'].includes(v),
    },
  },
  computed: {
    navGroups() {
      return NAV_GROUPS;
    },
    wrapperTag() {
      return this.variant === 'mobile' ? 'nav' : 'div';
    },
    wrapperClass() {
      return this.variant === 'mobile' ? 'hc-sidenav hc-sidenav--mobile' : 'hc-sidenav hc-sidenav--desktop';
    },
    showCompletionWidget() {
      return this.profileCompletionPercent < 100;
    },
  },
};
</script>
